<template>
  <section class="google-auth-modal__step">
    <div class="step-qr__wrapper">
      <img class="step-qr__qr-image" :src="qrImage" />
      <div class="google-auth-modal__step-info">
        Install Google Authenticator from your phone’s app store, then scan the
        QR code above.
      </div>
    </div>
    <div class="google-auth-modal__step-btn-wrapper">
      <button
        type="submit"
        class="btn btn--primary google-auth-modal__step-next-btn"
        @click="$emit('go-next-step')"
      >
        Next
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'StepQR',
  props: {
    gaQrCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isSaveDisabled: true,
    }
  },
  computed: {
    qrImage() {
      return `data:image/svg+xml;base64,${this.gaQrCode}`
    },
  },
}
</script>

<style lang="scss" scoped>
.step-qr {
  &__qr-image {
    margin-top: 20px;
    width: 176px;
    height: 176px;
  }
  &__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 30px;
  }
  &__input {
    max-width: 100%;
    input {
      height: 38px;
      padding: 11px;
      @include mobile {
        height: 46px;
      }
    }
  }
}
</style>
